module.exports = require("../../../../lib").stronachgroup.first.auth;
